import React from "react";
import shortid from "shortid";

import {
  Box,
  Button,
  Checkbox,
  Column,
  Columns,
  Control,
  Field,
  Input,
  Select,
  Table,
} from "@allxsmith/bestax-bulma";

import Part from "./Part";
import {getPartCustomerCost, getPartCustomerEstimatedCost, getWorkItemCustomerCost} from "../../utils";
import WorkTypePicker from "./WorkTypePicker";
import TrackingOptionsPicker from "../Settings/TrackingCategory/TrackingOptionsPicker";
import TaxTypePicker from "../Settings/NominalCodes/TaxTypePicker";



function WorkSection(props) {
  const handleChange = e => {
    const newWorkItem = getNewWorkItem(e);
    props.update_work(newWorkItem, props.index);
  };

  const handleTickBox = e => {
    const toUpdate = {
      target: {
        name: "approval_received",
        value: !props.workItem.approval_received
      }
    };
    handleChange(toUpdate);
  }


  const handleTypeSelect = e => {
    let value = e.target.value === "BLANK" ? null : props.workTypeObjects[e.target.value];
    const toUpdate = {
      target: {
        name: "work_type",
        value: value
      }
    };
    handleChange(toUpdate);
  }

  const handleTrackingCategoryChange = (e) => {
    const toUpdate = {
      target: {
        name: e.target.name,
        value: props.trackingOptionObjects[e.target.value]
      }
    };
    handleChange(toUpdate);
  }

  const getNewWorkItem = e => {
    let chargeable =
      e.target.name === "chargeable"
        ? e.target.value
        : props.workItem.chargeable;
    let customer = chargeable ? props.hireCustomer : props.customer;

    let newWorkItem = { ...props.workItem, [e.target.name]: e.target.value };
    if (
      (e.target.name === "labour_hours" ||
        e.target.name === "chargeable" ||
        e.target.name === "cost_override") &&
      !newWorkItem.cost_override && !newWorkItem.movement
    ) {
      // If the work item is linked to a movement, do not recalculate its cost
      newWorkItem = getWorkItemCustomerCost(props.vehicle, props.supplier, newWorkItem, customer, props.lcv_job);
    }
    return newWorkItem;
  };

  const onCheck = propName => {
    const newWorkItem = getNewWorkItem({
      target: {
        name: propName,
        value: !props.workItem[propName]
      }
    });
    newWorkItem.parts = props.workItem.parts.map(part => {
      return {
        ...part,
        customer_cost: getPartCustomerCost(
          part,
          newWorkItem.chargeable ? props.hireCustomer : props.customer,
          props.appDefaults
        ),
        estimated_customer_cost: getPartCustomerEstimatedCost(
          part,
          newWorkItem.chargeable ? props.hireCustomer : props.customer,
          props.appDefaults
        )
      };
    });
    props.update_work(newWorkItem, props.index);
  };

  const addPart = e => {
    props.update_work(
      {
        ...props.workItem,
        parts: props.workItem.parts.concat({
          key: shortid.generate(),
          name: "",
          cost: 0,
          supplier: {},
          date_ordered: null,
          part_invoice_number: "",
          part_number: "",
          from_stock: false,
          backorder_expected_date: null,
          to_be_ordered: true,
          cost_override: false,
          customer_cost: 0,
          cost_vat: "INPUT2",
          quote: props.workItem.quote,
          supplier_tracking_option: null,
          customer_tracking_option: null,
          arrived: false
        })
      },
      props.index
    );
  };

  const updateParts = (part, index) => {
    let newParts = [...props.workItem.parts];
    newParts.splice(index, 1, part);
    const newWorkItem = {
      ...props.workItem,
      parts: newParts
    };
    props.update_work(newWorkItem, props.index);
  };

  const removePart = index => {
    let newParts = [...props.workItem.parts];
    newParts.splice(index, 1);
    const newWorkItem = {
      ...props.workItem,
      parts: newParts
    };
    props.update_work(newWorkItem, props.index);
  };

  const getDisabled = (field, work, approvedField) => {
      // If the part has been approved and the box has been filled then it should be disabled
      if(work[approvedField]){
          if(work[field] && work[field].id){
              return true
          }
      }
      return false
  }

  const allMatches = props.workItem.estimate_matches_job;

  const borderClass = props.workItem.complete ? "box-border-green" : ""

  return (
    <Box className={borderClass}>
      {props.quote && (
        <Columns isMultiline>
          <Column>
            <p>This item is associated with a Quote!</p>
          </Column>
          <Column>
            {allMatches ? (
              ""
            ) : (
              <p>This work item doesn't match the quote!</p>
            )}
          </Column>
        </Columns>
      )}
      <Columns isMultiline>
        <Column>
          <Field>
            <Control>
              <label className="label">Description</label>
              <Input
                data-testid="description"
                type="text"
                name="description"
                onChange={handleChange}
                value={props.workItem.description}
                disabled={props.workItem.invoice_approved}
                required
              />
            </Control>
          </Field>
        </Column>
      </Columns>
      <Columns isMultiline>
        <Column>
          <Field>
            <Control>
              <label className="label">Charge Customer 2</label>
              <Checkbox
                type="checkbox"
                name="chargeable"
                onChange={() => onCheck("chargeable")}
                checked={props.workItem.chargeable}
                disabled={!props.hireCustomer || props.workItem.invoice_approved}
              />
            </Control>
          </Field>
        </Column>
        {props.workItem.quote && (
          <Column>
            <Field>
              <Control>
                <label className="label">Est. Labour Hours</label>
                <Input
                  data-testid="estimated_labour_hours"
                  className="input"
                  type="number"
                  name="estimated_labour_hours"
                  readOnly
                  disabled
                  value={String(props.workItem.estimated_labour_hours)}
                />
              </Control>
            </Field>
          </Column>
        )}
        {props.workItem.quote && (
          <Column>
            <Field>
              <label className="label">Est. Labour Cost</label>
              <Control>
                <Input
                  className="input"
                  type="number"
                  name="estimated_labour_cost"
                  readOnly
                  disabled
                  value={String(props.workItem.estimated_labour_cost)}
                />
              </Control>
            </Field>
          </Column>
        )}
        {props.workItem.quote && (
          <Column>
            <Field>
              <label className="label">Est. Customer Charge</label>
              <Control>
                <Input
                  className="input"
                  type="number"
                  name="estimated_customer_labour_cost"
                  readOnly
                  disabled
                  value={String(props.workItem.estimated_customer_labour_cost)}
                />
              </Control>
            </Field>
          </Column>
        )}
        <Column>
          <Field>
            <Control>
              <label className="label">Labour Hours</label>
              <Input
                data-testid="labour_hours"
                className="input"
                type="number"
                name="labour_hours"
                onChange={handleChange}
                value={String(props.workItem.labour_hours)}
                disabled={props.workItem.invoice_approved || !!props.workItem.movement}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Labour Cost</label>
            <Control>
              <Input
                className="input"
                type="number"
                name="labour_cost"
                onChange={handleChange}
                value={String(props.workItem.labour_cost)}
                disabled={!props.workItem.cost_override || props.workItem.invoice_approved || !!props.workItem.movement}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Customer Charge</label>
            <Control>
              <Input
                className="input"
                type="number"
                name="customer_labour_cost"
                onChange={handleChange}
                value={String(props.workItem.customer_labour_cost)}
                disabled={!props.workItem.cost_override || props.workItem.invoice_approved}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <label className="label">Labour VAT Rate</label>
          <TaxTypePicker
            onChange={handleChange}
            name={"labour_cost_vat"}
            disabled={props.workItem.invoice_approved}
            value={props.workItem.labour_cost_vat}
          />
        </Column>
        <Column>
          <Field>
            <Control>
              <label className="label">Override Cost</label>
              <Checkbox
                type="checkbox"
                name="cost_override"
                onChange={() => onCheck("cost_override")}
                disabled={props.workItem.invoice_approved}
                checked={props.workItem.cost_override}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <label className="label">Work Complete</label>
              <Checkbox
                type="checkbox"
                name="work_complete"
                onChange={() => onCheck("complete")}
                disabled={props.workItem.invoice_approved || !!props.workItem.movement}
                checked={props.workItem.complete}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <TrackingOptionsPicker
            name={"supplier_tracking_option"}
            label={"Workshop Expense Tracking Option"}
            value={props.workItem.supplier_tracking_option}
            onChange={handleTrackingCategoryChange}
            blank={true}
            disabled={getDisabled("supplier_tracking_option", props.workItem, "po_approved")}
            inlineEdit={false}
            editable={true}
            options={props.trackingOptions}
          />
        </Column>
        <Column>
          <TrackingOptionsPicker
            name={"customer_tracking_option"}
            label={"Workshop Invoicing Tracking Option"}
            value={props.workItem.customer_tracking_option}
            onChange={handleTrackingCategoryChange}
            blank={true}
            disabled={getDisabled("customer_tracking_option", props.workItem, "invoice_approved")}
            inlineEdit={false}
            editable={true}
            options={props.trackingOptions}
          />
        </Column>
      </Columns>
      <Columns isMultiline>
        <Column>
          <WorkTypePicker
            options={props.workTypes}
            work={props.workItem}
            onSelect={handleTypeSelect}
            inlineEdit={false}
            disabled={props.workItem.invoice_approved}
          />
        </Column>
        {props.workItem.work_type && props.workItem.work_type.warranty_claim &&
        <Column>
          <label className="label">Claimed Warranty</label>
          <Select
            name={"warranty_claimed"}
            onChange={handleChange}
            value={props.workItem.warranty_claimed}
          >
            <option key={0} value={"BLANK"}></option>
            <option key={1} value={"true"}>Yes</option>
            <option key={2} value={"false"}>No</option>
          </Select>
        </Column>
        }
        {props.workItem.work_type && props.workItem.work_type.approval_needed &&
          <Column>
            <Field>
              <label className="label">Approval Received</label>
              <Checkbox
                name={"approval_received"}
                onChange={handleTickBox}
                checked={props.workItem.approval_received}
                disabled={props.workItem.invoice_approved}
              />
            </Field>
          </Column>
        }
        <Column size={8}></Column>
      </Columns>
      <Table isFullwidth>
        <thead>
          <tr>
            <td>Name</td>
            {props.quote && <td>Est. Cost</td>}
            {props.quote && <td>Est. Charge</td>}
            <td>Supplier</td>
            <td>Part Expense Tracking Option</td>
            <td>Workshop Invoicing Tracking Option</td>
            <td>Date Ordered</td>
            <td>Part Number</td>
            <td>Invoice No</td>
            <td>Actual Cost</td>
            <td>Actual Charge</td>
            <td>VAT Rate</td>
            <td>Comments</td>
            <td>Override Cost</td>
            <td>Postage</td>
            <td>Stock Accrual</td>
            <td>Backorder Date</td>
            <td>To Be Ordered</td>
            <td>Arrived</td>
            <td>Remove</td>
          </tr>
        </thead>
        <tbody data-testid="parts">
          {props.workItem.parts.map((part, index) => (
            <Part
              key={part.id || part.key}
              index={index}
              part={part}
              job={props.job}
              quote={props.quote}
              updateParts={updateParts}
              removePart={removePart}
              customer={
                props.workItem.chargeable ? props.hireCustomer : props.customer
              }
              appDefaults={props.appDefaults}
              onSearchPartClick={(part, partIndex) =>
                props.onSearchPartClick(
                  part,
                  partIndex,
                  props.index,
                  props.customer
                )
              }
              invoiced={props.workItem.invoice_approved}
              trackingOptions={props.trackingOptions}
              trackingOptionObjects={props.trackingOptionObjects}
            />
          ))}
        </tbody>
      </Table>
      <Button
        color="primary"
        onClick={addPart}
        data-testid="add-part"
        disabled={
          (!!(props.workItem.quote && !props.workItem.added_after_quote) ||
          !!props.workItem.invoice_approved || !!props.workItem.movement) || !(!!props.workItem.supplier_tracking_option || !!props.workItem.customer_tracking_option)
        }
      >
        Add Part
      </Button>
      <Button
        color="danger"
        data-testid="remove-work"
        className="is-pulled-right remove-work"
        onClick={() => props.remove_work_item(props.index)}
        disabled={!!props.workItem.invoice_approved || !!props.workItem.movement}
      >
        Remove Work
      </Button>
    </Box>
  );
}

export default WorkSection;
